import { render } from "./topic-card-detailed.vue?vue&type=template&id=5d8c5bfa&ts=true"
import script from "./topic-card-detailed.vue?vue&type=script&lang=ts"
export * from "./topic-card-detailed.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__